import React from 'react';
import { observer } from 'mobx-react-lite';
import Grid from '@material-ui/core/Grid';
import { useRootStore } from '../../../../mobx/bridge';
import EditCannedMessages from '../EditCannedMessages/EditCannedMessages';
import * as utils from '../../../../helpers/utils';

// eslint-disable-next-line prefer-arrow-callback,sonarjs/cognitive-complexity
const MainComponent = observer(function MainComponent() {
  const { commonStore } = useRootStore();

  let component;

  if (commonStore.mainComponentOpen === utils.mainComponentOpen.editCannedMessages) {
    component = <EditCannedMessages />;
  }

  return (
    <Grid component="div" item xs={12}>
      {component}
    </Grid>
  );
});

export default MainComponent;
